export default __webpack_public_path__ + "static/media/icon-camera.cd3f98fd.svg";